export default {
  path: "/classroomMap",
  name: "classroomMap",
  redirect: "/classroomMap/index",
  meta: {
    title: "教室地图",
    showMainMenu: false
  },
  children: [
    {
      path: "/classroomMap/index",
      name: "classroomMapIndex",
      component: () =>
        import(/* webpackChunkName: "classroomMap" */ "@/views/classroomMap/Index.vue"),
      meta: {
        title: "教室地图",
        showMainMenu: true,
        icon: "icon-map"
      }
    }
  ]
};
